import ReactDOM from 'react-dom/client'
//
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import * as Sentry from '@sentry/react'
import reportWebVitals from './reportWebVitals'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { SENTRY_DSN } from './config-global'
import { captureConsoleIntegration, httpClientIntegration } from '@sentry/integrations'

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    captureConsoleIntegration({ levels: ['error'] }),
    httpClientIntegration({ failedRequestStatusCodes: [[500, 599]] }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    if (event.exception) {
      const exception = event.exception.values[0]
      if (exception.type === 'UnhandledRejection' && exception.value.includes('Timeout')) {
        return null
      }
    }
    return event
  },
})

defineCustomElements(window).catch(console.error)

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
